var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPriceChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#D7DEDA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 1.5V7.16154L6.93333 4.94615L6 5.80769L10 9.5L14 5.80769L13.0667 4.94615L10.6667 7.16154V1.5H9.33333Z",
    fill: "#1C211E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 18.5V12.8385L6.93333 15.0538L6 14.1923L10 10.5L14 14.1923L13.0667 15.0538L10.6667 12.8385V18.5H9.33333Z",
    fill: "#1C211E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPriceChangeIcon);
export default __webpack_public_path__ + "static/media/NoPriceChangeIcon.2c1edc8f6c87462ecb1f95b30c1a9c1f.svg";
export { ForwardRef as ReactComponent };